import React from 'react';
import ReactDOM from 'react-dom';
import Rotas from './routes';
import 'react-perfect-scrollbar/dist/css/styles.css';

ReactDOM.render(
    <Rotas />
    , document.getElementById('root'));
